import { content as englishContent } from './en';

const content = {
  ...englishContent,
};

export { content };
